module.exports = __webpack_public_path__ + "img/D0D3BE_816854_998366_685146-256px.7db248d8.png";